import Select from 'react-select'
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();
const  data_fields = [
    {value: 'thumb', label: 'Featured Image  ( thumb )'},
    {value: 'icon', label: 'Package Icon  ( icon )'},
    {value: 'title', label: 'Post Title  ( title )'},
    {value: 'page_link', label: 'Linked Post Title  ( page_link )'},
    {value: 'date', label: 'Publish Date  ( date )'},
    {value: 'update_date', label: 'Update Date  ( update_date )'},
    {value: 'categories', label: 'Categories  ( update_date )'},
    {value: 'tags', label: 'Tags  ( tags )'},
    {value: 'download_count', label: 'Download Count  ( download_count )'},
    {value: 'audio_player', label: 'Audio Player  ( audio_player )'},
    {value: 'file_count', label: 'File Count  ( file_count )'},
    {value: 'package_size', label: 'Package Size  ( package_size )'},
    {value: 'download_link', label: 'Download Button  ( download_link )'},
    {value: 'details_link', label: 'Details Button  ( details_link )'}
    ];

class Sortable extends React.Component{
    constructor(props){
        super(props);
        this.state = {list: props.list, addcolcard: false, insertcoldata_label: null,  insertcoldata_field: null};
        this.deleteColumn = this.deleteColumn.bind(this);
        this.addColumn = this.addColumn.bind(this);
        this.hideAddColCard = this.hideAddColCard.bind(this);
        this.insertColumnHeader = this.insertColumnHeader.bind(this);
        this.insertColumn = this.insertColumn.bind(this);
    }
    componentDidMount(prevProps){
        let $this = this;
        jQuery('.sortable-list').sortable({
           update: function( event, ui ) {
               let colheads = jQuery( this ).find('.colheads');
               let result =  [];
               jQuery.each(jQuery( this ).find('.cols'), function (index, field) {
                   result.push({field: field.value, label:  colheads[index].value });
               })
               //$this.setState((prevState) => ({list: result}));
               $this.props.onUpdate(result);
           }
        });
    }

    componentDidUpdate(prevProps) {
        let $this = this;
        jQuery('.sortable-list').sortable({
            update: function( event, ui ) {
                let colheads = jQuery( this ).find('.colheads');
                let result =  [];
                jQuery.each(jQuery( this ).find('.cols'), function (index, field) {
                    result.push({field: field.value, label:  colheads[index].value });
                })
                //$this.setState((prevState) => ({list: result}));
                $this.props.onUpdate(result);
            }
        });
    }

    deleteColumn(_item){
        const field =  _item.currentTarget.id;
        this.setState((prevState) => ({list: prevState.list.filter((item) => item.field !== field)}));
        this.props.onDelete(this.state.list.filter((item) => item.field !== field));
    }

    addColumn(_item){
        this.setState((preState) => ({ addcolcard: true }));
    }

    insertColumnHeader(_item){
        let label  =_item.currentTarget.value;
        this.setState((preState) => ({ insertcoldata_label: label }));
    }

    insertColumn(_item){
        let _list =  this.state.list;
        _list.push({label:  this.state.insertcoldata_label, field:  this.state.insertcoldata_field});
        this.setState((prevState) => ({list: _list,  addcolcard: false}));
        this.props.onUpdate(_list);
    }

    hideAddColCard(_item){
        this.setState((preState) => ({ addcolcard: false }));
    }

    render(){
        function onSelectDataField(data_field){
            let fields = '';
            jQuery.each(data_field,  function (index, dataobj) {
                fields += dataobj.value;
            })

            this.setState((preState) => ({ insertcoldata_field: fields }));
        }
        return (
            <div  style={{position:  'relative'}}>
                {this.state.addcolcard === true &&
                <div className={"card m-0 hide add-column-card"}>
                    <div className={"card-header"}><i onClick={this.hideAddColCard.bind(this)} className={"float-right c-pointer fas fa-times-circle text-primary mt-1"}></i>Add Table Column</div>
                    <div className={"card-body"}>
                        <div className={"form-group"}>
                            <label>Column Header Title</label>
                            <input type={"text"} value={this.state.insertcoldata_label} onChange={this.insertColumnHeader.bind(this)} className={"form-control"}/>
                        </div>
                        <div className={"form-group mb-3"}>
                            <label>Column Data</label>
                            <Select
                                id={"data_fields"}
                                name={"data_fields"}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                isMulti
                                options={data_fields}
                                onChange={(data_field) => {
                                    let fields = [];
                                    jQuery.each(data_field,  function (index, dataobj) {
                                        fields.push(dataobj.value);
                                    })
                                    console.log(fields);
                                    this.state.insertcoldata_field = fields.join(',');
                                }}
                            />
                            <div style={{clear: 'both'}}></div>
                        </div>


                    </div>
                    <div className={"card-footer"}>
                        <button type={"button"} className={"btn btn-success btn-block"} onClick={this.insertColumn.bind(this)}>Insert Column</button>
                    </div>
                </div>
                }
                {this.state.addcolcard === false &&
                    <div>
                        <ul className={"list-group text-sm sortable-list"}  style={{overflow: 'hidden'}}>
                            {this.state.list.map((item) =>
                                <li style={{fontSize: '12px', padding: '10px'}} className={"list-group-item d-flex justify-content-between align-items-center m-0"}>
                                    <input type={"hidden"} className={"cols"} name={"cols[]"} value={item.field}/>
                                    <input type={"hidden"} className={"colheads"} name={"colheads[]"} value={item.label}/>
                                    <div className={"sorter"} style={{width: '16px', cursor: 'pointer'}}><i className="fas fa-arrows-alt-v text-info"></i></div>
                                    <div style={{width: 'calc(100% - 48px)', overflow: 'hidden'}}>
                                        <strong className={"d-block"}>{item.label}</strong>
                                        <span style={{textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', display: 'block'}} className={"text-muted"}>{item.field}</span>
                                    </div>
                                    <a href={"#"} style={{fontSize: '10px'}} onClick={this.deleteColumn.bind(this)} id={item.field} className={"btn btn-danger btn-sm delete-column"}><i className={"fas fa-trash"}></i></a>
                                </li>
                            )}
                        </ul>
                        <button className={"btn btn-primary btn-block btn-sm mt-2"} onClick={this.addColumn.bind(this)} type={"button"}>{"Add New Column"}</button>
                    </div>
                }
            </div>

        );
    }
}

export default Sortable;
